import React, { PropTypes } from "react";

const MessageBox = (props) => {
  const classes = "message-box " + props.className;
  return (
    <div key="message" className={classes}>
      <div className="message-content">{props.children}</div>
    </div>
  );
};

MessageBox.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  className: PropTypes.string,
};

export default MessageBox;



// WEBPACK FOOTER //
// ./src/components/common/MessageBox.js